"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOuterSize = void 0;
function getOuterSize(rect, computedStyles) {
    return {
        width: rect.width +
            parseFloat(computedStyles.marginLeft) +
            parseFloat(computedStyles.marginRight),
        height: rect.height +
            parseFloat(computedStyles.marginTop) +
            parseFloat(computedStyles.marginBottom),
    };
}
exports.getOuterSize = getOuterSize;
